import BranchInventoryTable from "./branchInventoryTable.container";

export default BranchInventoryTable;
